import { courses } from '../data/courses';
import type { Course } from '../types/content';

export function getCourse(slug: string): Course | undefined {
  return courses.find((c) => c.slug === slug);
}

export function coursePath(course: Course): string {
  return course.detailPath ?? `/courses/${course.slug}`;
}

export function formatPrice(value: number): string {
  return `$${value.toLocaleString('en-US')}`;
}

export function priceLabel(course: Pick<Course, 'price' | 'priceFrom'>): string {
  return `${course.priceFrom ? 'From ' : ''}${formatPrice(course.price)}`;
}
